import * as d3 from "d3";

/**
 * Computes a color based on a percentage value using a gradient from red (0%) to green (100%)
 * passing through yellow at 50%.
 * 
 * @param percentage - A number between 0 and 100 representing the percentage
 * @returns A color string in RGB format (e.g., "rgb(255, 0, 0)")
 * 
 * @example
 * ```typescript
 * const color = getColorFromPercentage(75); // Returns a yellowish-green color
 * ```
 */
export const getColorFromPercentage = (percentage: number): string => {
    // D3 color scale from red (0) to yellow (0.5) to green (1)
    const colorScale = d3.scaleLinear<string>()
        .domain([0, 0.5, 1])
        .range(["red", "orange", "green"]);
    
    // Normalize percentage to 0-1 range and compute color
    const normalizedValue = Math.max(0, Math.min(100, percentage)) / 100;
    return colorScale(normalizedValue);
};
